/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('magnific-popup');
import $clamp from 'clamp-js/clamp.js';
import Swiper from 'swiper/swiper-bundle.min';

import './vendor/jquery.fullpage.modified';
import initBlocks from './blocks';

import Site from './site-constructor';
import landingPage from './new-landing-constructor';
import Cookies from 'js-cookie';
import LazyLoad from 'vanilla-lazyload';
import { loadRecaptcha } from './grecaptcha';

// window.Vue = require('vue');
//
// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */
//
// Vue.component('example-component', require('./components/ExampleComponent.vue'));
//
// const app = new Vue({
//     el: '#app'
// });


import Turbolinks from "turbolinks";
/*$.getJSON( 'acTurbolinkFlag.json', function( json ) {
  let turbolinkFlag = json.turbolinks_mode;

  if (turbolinkFlag) {
    Turbolinks.start();
  }
});*/

class App {
  constructor() {
    this.lazyLoadInstance = new LazyLoad();
    this.initLanding();
    this.initPartners();
    this.initInterviews();
    // this.initGoogle();
    new Site();
    landingPage();
    this.handleCookies();
    this.initPostlist();
    this.initBlocksLocal();

    $('.article-gallery').length && this.initGalleryThumbs('.article-gallery__main', '.article-gallery__thums');
    $('.post-gallery').length && this.initGalleryThumbs('.post-gallery__main', '.post-gallery__thums');
    // if(thumbSlider.find('.swiper-slide').length < 2){
    //   thumbSlider.addClass("hide-block")
    // }
    // $clamp($('.editors-choose__text').get(0), { clamp: 4 });

    $('#js-subscribe-form').submit(function (e) {
      e.preventDefault();
      let $this = $(this);
      let $email = $this.find('#js-subscribe-email');
      let $agree = $this.find('#personal-data');
      if (!$email.val()) $this.find('#js-subscribe-form-error').show();
      else {
        $this.find('#js-subscribe-form-error').hide();
        if (!$agree.is(':checked')) $this.find('#agreement-error').show();
        else {
          $this.find('#agreement-error').hide();
          $.post($this.attr('action'), $this.serialize(), function (res) {
            $email.val('');
            $agree.prop('checked', false);
          });
        }
      }
    });

    $('.btn-menu').on('click', function () {
      $('.drop-menu').addClass('drop-menu--open');
      $('body').addClass('no-scroll');
    });
    $('.close').on('click', function () {
      $('.drop-menu').removeClass('drop-menu--open');
      $('body').removeClass('no-scroll');
    });

    $("#calltouch, #calltouchmain").click(
      function callButtonClick(e) {
        if (window.innerWidth > 767) {
          if (window.Calltouch) {
            e.preventDefault();
            window.Calltouch.Callback.onClickCallButton()
          } else {
            console.warn("calltouch не подключен")
          }
        }
      }
    );

    $('#my_call_form').on('submit', function (e) {
      if (typeof (window['ctCheckCallbackShouldBeProcessed']) == 'function') { //Если функция колбека инициализирована в скрипте Calltouch
        if (ctCheckCallbackShouldBeProcessed()) { // Проверяем следует ли отправлять заявку на обратный звонок
          e.preventDefault(); // Предотвращаем отправку формы до отправки заявки
          var phoneNumber = $('#phone_input').val(); // Получаем значения из поля для ввода номера телефона
          ctSendCallbackRequest(phoneNumber); // Отправляем заявку на обратный звонок
          var timer = setInterval(function () {
            console.log(ctGetCallbackRequestStatus());
            if (ctGetCallbackRequestStatus() != 'Попытка отправки заявки на обратный звонок.') {
              clearInterval(timer);
              console.log(ctGetCallbackRequestStatus());
            }
          }, 500);
          return false;
        }
      } else {
        console.warn("calltouch не подключен")
      }
    });

    $('.js-criteo, #callback-widget').on('click', function () {
      window.criteo_q = window.criteo_q || [];
      var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
      window.criteo_q.push(
        {event: "setAccount", account: 53847},
        {event: "setEmail", email: ""},
        {event: "setSiteType", type: deviceType},
        {
          event: "trackTransaction", id: Math.floor(Math.random() * 99999999999), item: [
            {id: 'home', price: 1, quantity: 1}
          ]
        }
      );
    });

    $('.js-show-text').on('click', function (e) {
      e.preventDefault();
      let $this = $(this);
      yaCounter48469394.reachGoal('press_next_button', null, () => {
        window.location.href = $this.attr('href');
      });
      // $(this).next('.post__text').removeClass('post__text--hidden');
      // $(this).hide();
    });


    $(document).ready(function () {
      $('#landing-conversive a').click(function (e) {
        let $this = $(this);
        fbq('track', 'Lead');
        yaCounter48469394.reachGoal('perehod_klient', null, () => {
          window.location.href = $this.attr('href');
        });
      });
    });

    $(".post__content").each(function () {
      var $minHeight = 1000;
      if ($(this).height() < $minHeight) {
        $('.share-topblock').addClass('share-botblock__hide')
        $('.share-botblock').removeClass('share-topblock__hide')

      } else {
        $('.share-botblock').addClass('share-botblock__hide')
        $('.share-topblock').removeClass('share-topblock__hide')
      }
    });

    $('.post__content table').wrap('<div class="table" />')
  }

  initBlocksLocal() {
    initBlocks();
  }

  initPostlist(){
    let cont = null;
    let $interviewSlider = $('.js-slider');

    let interviewSlider = () => {
      return new Swiper('.js-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        preloadImages: false,
        lazy: true,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: '.interview-slider-nav--next',
          prevEl: '.interview-slider-nav--prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 25,
          }
        }
      });
    };

    let checkCreateSlider = () => {
      if ($interviewSlider.length) {
        // if (window.innerWidth <= 767) {
        //   if (cont) {
        //     cont.destroy();
        //     cont = null;
        //   }
        // } else {
        if (!cont) {
          cont = interviewSlider();
        }
        // }
      }
    };
    $(window).on('resize.cont', function () {
      checkCreateSlider();
    }).trigger('resize.cont')
  }

  initGalleryThumbs(main, thumbs) {
    let mainSlider = new Swiper(main, {
      slidesPerView: 1,
      allowTouchMove: false,
      preloadImages: false
    });


    let thumbSlider = new Swiper(thumbs, {
      spaceBetween: 15,
      slidesPerView: 3,
      slideToClickedSlide: true,
      preloadImages: false,
      centeredSlides: true,
      loop: true,
      loopedSlides: 10,
      navigation: {
        nextEl: '.thumb-next',
        prevEl: '.thumb-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 5,
          spaceBetween: 10
        }
      },
    });

    thumbSlider.on('slideChange', (...arg) => {
      mainSlider.slideTo(thumbSlider.realIndex)
    });
  }

  initLanding() {

    this.$topSlider = $('.landing__top-slider');
    this.$landingSliders = $('.landing-slider__container');

    if (this.$topSlider.length && ($(window).width() > 991)) {
      let topSlider = new Swiper('#top-slider', {
        slidesPerView: 2,
        spaceBetween: 25,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        navigation: {
          nextEl: '.landing__top-slider-nav--next',
          prevEl: '.landing__top-slider-nav--prev',
        },
        breakpoints: {
          1260: {
            slidesPerView: 3,
            spaceBetween: 25,
          }
        }
      })
    } else {
      this.$topSlider.hide();
    }

    if (this.$landingSliders.length) {
      this.$landingSliders.each(function () {
        let navNext = $(this).siblings('.landing-slider__nav--next');
        let navPrev = $(this).siblings('.landing-slider__nav--prev');
        new Swiper($(this)[0], {
          slidesPerView: 2,
          spaceBetween: 30,
          allowTouchMove: false,
          preloadImages: false,
          navigation: {
            nextEl: navNext[0],
            prevEl: navPrev[0],
          },
          breakpoints: {
            991: {
              slidesPerView: 1,
              //spaceBetween: 0
            }
          }
        })
      });

    }
  }

  initPartners() {
    function scrollNav() {
      $('.partner-material__aside-list a').click(function (e) {
        e.preventDefault();

        $('html, body').stop().animate({
          scrollTop: $($(this).attr('href')).offset().top
        }, 300);
        return false;
      });
    }

    scrollNav();


  }

  initInterviews() {

    let cont = null;
    let $interviewSlider = $('.interview__slider');

    let interviewSlider = () => {
      return new Swiper('.interview__slider', {
        slidesPerView: 1,
        spaceBetween: 25,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: '.interview-slider-nav--next',
          prevEl: '.interview-slider-nav--prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 50,
          }
        }
        });
    };

    let checkCreateSlider = () => {
      if ($interviewSlider.length) {
        // if (window.innerWidth <= 767) {
        //   if (cont) {
        //     cont.destroy();
        //     cont = interviewSlider();
        //   }
        // } else {
          if (!cont) {
            cont = interviewSlider();
          }
        // }
      }
    };

    $(window).on('resize.cont', function () {
      checkCreateSlider();
    }).trigger('resize.cont')


    let $clampCont = $(".interview__desc");

    if (window.innerWidth < 480) {
      let clamper = $clampCont.each(function () {
        $clamp(this, {clamp: 3});
      })
    }

  }

  initGoogle() {
    $('.js-ga').on('click', function (e) {
      e.preventDefault();
      const url = $(e.currentTarget).attr('href');
      const result = url.match(/[https]:\/\/(.*?)\//);
      gtag('event', 'click', {'event_action': 'переход', 'event_category': 'сайт_клиента', 'event_label': result[1]});
      setTimeout(function () {
        window.location.href = url
      }, 500)
    });
  }

  handleCookies() {
    const $mobal = $('.bg_popupse');

    if (!Cookies.get('cookie_done')) {
      setTimeout(() => {
        $mobal.addClass('bg_popupse--show');
      },1000);
    }
    $('.cookies-btn').on('click', (e) => {
      e.preventDefault();
      Cookies.set('cookie_done', 1, { expires: 3650 });
      $mobal.removeClass('bg_popupse--show');
      $mobal.hide();
    });

    $('.cookies-end').on('click', () => {
      $mobal.removeClass('bg_popupse--show');
      $mobal.hide();
    })
  }
}

function init() {
  console.log('init');
  window.app = new App();

  $(document).on('focus', 'form input', function() {
    const $form = $(this).parents('form');
    const $grecapthca = $form.find('.g-recaptcha');
    const siteKey = $grecapthca.data('sitekey');

    if($grecapthca.length && !$grecapthca.hasClass('load-ready')) {
      loadRecaptcha().then(() => {
        window.grecaptcha.render($grecapthca[0], {
          sitekey: siteKey
        });
        $grecapthca.addClass('load-ready');
      });
    }
  });

  if(window.Ya && window.Ya.adfoxCode) {
    window.Ya.adfoxCode.clearSession();
  }
}

if (window.turbolinks_enabled) {
  Turbolinks.HttpRequest.prototype.requestLoaded = function() {
    return this.endRequest(function() {
      var code = this.xhr.status;
      if (200 <= code && code < 300 ||
          code === 403 || code === 404 || code === 500) {
        this.delegate.requestCompletedWithResponse(
            this.xhr.responseText,
            this.xhr.getResponseHeader("Turbolinks-Location"));
      } else {
        this.failed = true;
        this.delegate.requestFailedWithStatusCode(code, this.xhr.responseText);
      }
    }.bind(this));
  };
  Turbolinks.start();
  document.addEventListener("turbolinks:load", init);
  document.addEventListener('turbolinks:before-render', function () {
    window.Comagic = undefined;
    window.ComagicWidget = undefined;
    window.ComagicJsonp = undefined;
    window.__cs = undefined;
    window.__isComagicScriptLoaded = undefined;
  });

  $(document).on('turbolinks:click', function (event) {
    if (event.target.getAttribute('href').charAt(0) === '#') {
      return event.preventDefault()
    }

    if (event.target.classList.contains('js-turbolinks-off')) {
      event.preventDefault();
    }
  });

} else {
  $(init);
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js